import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import CopyRight from "./layout/CopyRight";
import Footer from "./layout/Footer";
import CtaArea from "./layout/CtaArea";
import Header from "./layout/Header";
import Home from "./page/Home";
import About from "./page/About";
import EventMainPage from "./page/Event";
import EventDetailsPage from "./page/EventDetails";
import MakeDonationPage from "./page/MakeDonation";
import BlogMainPage from "./page/Blog";
import Causes from "./page/Causes";
import CausesDetsils from "./page/CausesDetsils";
import GalleryPage from "./page/Gallery";
import NewsPage from "./page/News";
import NewsDetailsPage from "./page/NewsDetails";
import TestimonialPage from "./page/Testimonial";
import TeamPage from "./page/Team";
import LoginPage from "./page/Login";
import RegisterPage from "./page/Register";
import FaqsPage from "./page/Faqs";
import PrivacyPolicy from "./page/PrivacyPolicy";
import TermsServicePage from "./page/TermsService";
import ContactPage from "./page/Contact";
import ImageGuidePage from "./page/ImageGuide";
import Error from "./page/Error";
import { AuthProvider } from "./context/AuthContext";
import AdminRoute from "./admin/AdminRoute";
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import AdminMembers from "./admin/AdminMembers";
import AdminCms from "./admin/AdminCms";
import AdminImages from "./admin/AdminImages";
import AdminEvents from "./admin/AdminEvents";
import MemberRoute from "./member/MemberRoute";
import MemberLayout from "./member/MemberLayout";
import MemberDashboard from "./member/MemberDashboard";
import MemberProfile from "./member/MemberProfile";
import EventDbDetail from "./page/EventDbDetail";

function AppRoutes() {
  const location = useLocation();
  const hidePublicChrome =
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/member");

  return (
    <>
      {!hidePublicChrome && <Header />}
      <Routes>
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminLayout />
            </AdminRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="members" element={<AdminMembers />} />
          <Route path="cms" element={<AdminCms />} />
          <Route path="images" element={<AdminImages />} />
          <Route path="events" element={<AdminEvents />} />
        </Route>
        <Route
          path="/member"
          element={
            <MemberRoute>
              <MemberLayout />
            </MemberRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<MemberDashboard />} />
          <Route path="profile" element={<MemberProfile />} />
        </Route>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/event" element={<EventMainPage />} />
        <Route path="/events/:eventId" element={<EventDbDetail />} />
        <Route path="/event-details" element={<EventDetailsPage />} />
        <Route path="/make-donation" element={<MakeDonationPage />} />
        <Route path="/blog" element={<BlogMainPage />} />
        <Route path="/causes" element={<Causes />} />
        <Route path="/cause-details" element={<CausesDetsils />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/news-details" element={<NewsDetailsPage />} />
        <Route path="/testimonial" element={<TestimonialPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/faqs" element={<FaqsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-service" element={<TermsServicePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/image-guide" element={<ImageGuidePage />} />
        <Route path="*" element={<Error />} />
      </Routes>
      {!hidePublicChrome && (
        <>
          <CtaArea />
          <Footer />
          <CopyRight />
        </>
      )}
    </>
  );
}

const App = () => (
  <AuthProvider>
    <AppRoutes />
  </AuthProvider>
);

export default App;
